import { useEffect, useState } from "react";
import NotesSVG from "../../utils/assets/client/writing.svg";
import ProfileIcon from "../../components/client/ProfileIcon";
import ProfileSVG from "../../utils/assets/client/user.svg";
import InternalLinkSVg from "../../utils/assets/internal-link.svg";
import AdminIcon from "../../utils/assets/settings.svg";
const AdminComments = ({ notesData, submit, header }) => {
  const [note, setNote] = useState("");
  const [isSelected, setIsSelected] = useState(false);
  const [updatedNotes, setUpdatesNotes] = useState([]);

  useEffect(() => {
    const sortCommentsByLatest = (comments) => {
      return [...comments].sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
    };
    const sortedComments = sortCommentsByLatest(notesData);
    setUpdatesNotes(sortedComments);
  }, [notesData]);

  return (
    <div className="bg-white">
      <div className="row  border_bg_col overflow-hidden">
        <p className="txt-head bg-black text-white px-3 p-2">{header}</p>
        <div className="d-flex">
          <div
            onClick={() => setIsSelected(false)}
            className={`d-flex justify-content-start align-items-center cmntTabs ${
              !isSelected && "activeTab"
            } pointer`}
          >
            <img src={NotesSVG} width={20} height={20} alt="" />
            <span className="mx-2">Diagnostic Notes</span>
          </div>
          <div
            onClick={() => setIsSelected(true)}
            className={`d-flex mx-3 justify-content-start align-items-center cmntTabs ${
              isSelected && "activeTab"
            } pointer`}
          >
            <img src={InternalLinkSVg} width={20} height={20} alt="" />
            <span className="mx-2">Internal Notes</span>
          </div>
        </div>

        <hr className="my-2" />
        <div>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              submit(note, isSelected);
              setNote("");
            }}
            className="d-flex justify-content-center align-items-center py-3"
          >
            <div>
              <ProfileIcon photo={AdminIcon} />{" "}
            </div>
            <input
              type="text"
              placeholder="Write notes here..."
              className="form-control mx-2 card_radius"
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
            <button
              disabled={!note}
              type="submit"
              className="btn card_radius btn-sm btn-dark text-white py-2 px-4"
            >
              Save
            </button>
          </form>
          <div>
            {updatedNotes && updatedNotes.length > 0 ? (
              updatedNotes.map((item) => {
                return (
                  <>
                    <hr />
                    <div className="d-flex mx-0 mx-md-2 mx-lg-2 my-3">
                      <div className="mx-3">
                        {item?.from_user?.type === "admin" ? (
                          <ProfileIcon photo={AdminIcon} />
                        ) : (
                          <AvatarSVG
                            initial={item?.from_user?.first_name?.charAt(0)}
                          />
                        )}
                        {/* <ProfileIcon photo={ProfileSVG} /> */}
                      </div>

                      <div
                        className="d-flex flex-column"
                        style={{ fontSize: "15px" }}
                      >
                        <p className="text-primary m-0">
                          {item.from_user.first_name} {item.from_user.last_name}
                          <span className="text-black">
                            {" "}
                            Added a Note{" "}
                          </span>{" "}
                        </p>
                        <span className="" style={{ fontSize: "14px" }}>
                          {item.note}
                        </span>
                        <span
                          className="txt-secondary"
                          style={{ fontSize: "14px" }}
                        >
                          {new Date(item.created_at)
                            .toLocaleString("en-GB", {
                              day: "2-digit",
                              month: "short", // Short month name (e.g., Jan, Feb, Dec)
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                            })
                            .replace(",", "")}
                        </span>
                      </div>
                    </div>
                  </>
                );
              })
            ) : (
              <>
                <hr />
                <div className="p-2 pb-4">No Records for Notes</div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminComments;

export const AvatarSVG = ({ initial = "?" }) => {
  return (
    <svg
      width="40"
      height="40"
      className="bg-secondary rounded-circle text-black"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="#fff" />
      <text
        x="50%"
        y="50%"
        dominantBaseline="central"
        textAnchor="middle"
        fontSize="16"
        fill="black"
        fontFamily="Arial, sans-serif"
      >
        {initial.toUpperCase()}
      </text>
    </svg>
  );
};
